var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnTrack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 6.5,
    stroke: "#098E1D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 16C10.8565 16 12.637 15.2625 13.9497 13.9497C15.2625 12.637 16 10.8565 16 9C16 7.14349 15.2625 5.36301 13.9497 4.05025C12.637 2.7375 10.8565 2 9 2L9 9L9 16Z",
    fill: "#098E1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnTrack);
export default __webpack_public_path__ + "static/media/onTrack.46728a312ca15674d6da67c5083f1eaa.svg";
export { ForwardRef as ReactComponent };